import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  HostListener
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';

import {
  HttpClient
} from '@angular/common/http';

import {
  Sidebar
} from '../../components/sidebar/sidebar';

import {
  Banner
} from '../../components/banner/banner';

import {
  Features
} from '../../components/features/features';

import {
  PopularBrands
} from '../../components/popular-brands/popular-brands';

import {
  ShopMore
} from '../../components/shop-more/shop-more';

import {
  Footer
} from '../../components/footer/footer';

import {
  AdSlot
} from '../../components/ad-slot/ad-slot';

import {
  ProductSection
} from '../../components/product-section/product-section';

import {
  ProductService
} from '../../services/product.service';

import {
  CategoryService
} from '../../services/category.service';

import {
  CartService
} from '../../services/cart';

import {
  ProductStateService
} from '../../services/product-state.service';

import {
  LanguageService
} from '../../services/language.service';

import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BnNumberPipe } from '../../pipes/bn-number.pipe';
import { FilterSidebar, ProductFilters } from '../../components/filter-sidebar/filter-sidebar';
import {
  HomepageLayoutService,
  HomeSection,
  defaultSections
} from '../../services/homepage-layout.service';

@Component({
  selector: 'app-home',

  standalone: true,

 imports: [
  CommonModule,
  FilterSidebar,
  FormsModule,
  Sidebar,
  Banner,
  Features,
  ShopMore,
  PopularBrands,
  Footer,
  AdSlot,
  ProductSection,
  BnNumberPipe
],

  templateUrl: './home.html',

  styleUrls: ['./home.css']
})
export class Home implements OnInit {


  // =========================
  // PRODUCTS SECTION
  // =========================

  @ViewChild('productsSection')
  productsSection?: ElementRef<HTMLElement>;


  // =========================
  // MOBILE MENU
  // =========================

  mobileMenuOpen = false;


  // =========================
  // PRODUCTS
  // =========================

  allProducts: any[] = [];

  originalProducts: any[] = [];

  filtered: any[] = [];

  // সার্চের আসল রেজাল্ট — ফিল্টার এর ওপর চালিয়ে filtered বানানো হয়
  searchBase: any[] = [];


  // =========================
  // HOME SECTIONS (Sindabad-এর মতো)
  // =========================

  hotDeals: any[] = [];

  recommended: any[] = [];

  trending: any[] = [];


  // =========================
  // POPULAR CATEGORIES
  // ADMIN CONTROLLED
  // =========================

  popularCategories: any[] = [];


  // =========================
  // HOMEPAGE LAYOUT
  // অ্যাডমিন → হোমপেজ ডিজাইন থেকে আসে (ক্রম / দেখানো-লুকানো / টাইটেল)
  // =========================

  sections: HomeSection[] = defaultSections();

  get visibleSections(): HomeSection[] {
    return this.sections.filter(s => s.enabled);
  }

  trackSection(index: number, s: HomeSection): string {
    return s.sectionKey;
  }

  // টাইটেল: অ্যাডমিনের দেওয়া ভাষা-অনুযায়ী টাইটেল; ফাঁকা থাকলে ডিফল্ট অনুবাদ
  sectionTitle(s: HomeSection, emptyIfDefault = false): string {

    const bn = this.languageService.language() === 'bn';

    const custom = (bn ? s.titleBn : s.titleEn) || '';

    if (custom.trim()) {
      return custom.trim();
    }

    if (emptyIfDefault) {
      return '';
    }

    return this.t('popularCategories');
  }

  limitedPopularCategories(s: HomeSection): any[] {

    const n = Number(s.itemLimit) || 0;

    return n > 0
      ? this.popularCategories.slice(0, n)
      : this.popularCategories;
  }


  // =========================
  // LOADING
  // =========================

  loading = false;


  // =========================
  // VIEW MODE
  // =========================

  viewMode:
    'products' |
    'categories'
    = 'products';


  // =========================
  // SELECTED CATEGORY
  // =========================

  selectedCategory: any = null;


  // =========================
  // SEARCH
  // =========================

  currentSearch = '';

  // =========================
  // BREADCRUMB
  // =========================

  breadcrumb: string[] = [];


  // =========================
  // API URL
  // =========================

  apiUrl =
    'https://superbangladesh-api-1.onrender.com';

  // MOBILE ORDER BAR - CHAT BUTTON
  // Admin panel > Footer Management > WhatsApp Number থেকে বদলানো যায়
  whatsappNumber = '8801756442133';


  // =========================
  // CONSTRUCTOR
  // =========================

  constructor(
    private productService:
      ProductService,

    private categoryService:
      CategoryService,

    public cart:
      CartService,

    private state:
      ProductStateService,

    private cdr:
      ChangeDetectorRef,

    public languageService:
      LanguageService,
      private router: Router,
      private http: HttpClient,
      private layout: HomepageLayoutService
  ) {}


  /* =========================
     TRANSLATE
  ========================= */

  t(
    key: string
  ): string {

    return this.languageService
      .translate(key);
  }


  /* =========================
     CATEGORY NAME
  ========================= */

  categoryName(
    category: any
  ): string {

    return this.languageService
      .translateCategory(
        category?.name,
        category?.nameBn
      );
  }


  // =========================
  // INIT
  // =========================

  ngOnInit(): void {

    this.loadAll();

    this.loadPopularCategories();

    this.layout.getSections().subscribe(list => {
      this.sections = list;
      this.cdr.detectChanges();
    });


    // MOBILE ORDER BAR চ্যাট বাটনের জন্য WhatsApp নম্বর লোড হচ্ছে
    this.http
      .get<any>(`${this.apiUrl}/api/footer-settings/active`)
      .subscribe({
        next: (res) => {

          if (res?.whatsappNumber) {
            this.whatsappNumber = res.whatsappNumber;
          }
        },
        error: () => {}
      });


    // SEARCH STATE

    this.state.search$
      .subscribe((value: string) => {

        this.currentSearch =
          value || '';

        this.applySearch();

        this.cdr.detectChanges();

        if (
          this.currentSearch.trim()
        ) {

          setTimeout(() => {

            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });

          }, 0);

        }

      });

    // CATEGORY STATE

    this.state.category$
      .subscribe((id: number) => {

        console.log(
          'STATE CATEGORY =',
          id
        );


        if (
          id === undefined ||
          id === null ||
          id === 0
        ) {
          return;
        }


        this.loadProducts(
          Number(id)
        );
      });
  }


  // =========================
  // LOAD POPULAR CATEGORIES
  // ADMIN CONTROLLED
  // =========================

  loadPopularCategories(): void {

    this.categoryService
      .getPopular()
      .subscribe({

        next: (res: any[]) => {

          console.log(
            'POPULAR CATEGORIES =',
            res
          );

          this.popularCategories =
            Array.isArray(res)
              ? res
              : [];

          this.cdr.detectChanges();
        },

        error: (err: any) => {

          console.error(
            'POPULAR CATEGORY ERROR =',
            err
          );

          this.popularCategories = [];

          this.cdr.detectChanges();
        }

      });
  }


  // =========================
  // MOBILE MENU
  // =========================

  toggleMobileMenu(): void {

    this.mobileMenuOpen =
      !this.mobileMenuOpen;
  }


  // =========================
  // LOAD ALL PRODUCTS
  // =========================

  loadAll(): void {

    this.loading = true;


    this.viewMode =
      'products';


    this.selectedCategory =
      null;


    this.productService
      .getProductsCached()
      .subscribe({

        next: (res: any[]) => {

          console.log(
            'ALL PRODUCTS =',
            res
          );


          // STORE ALL PRODUCTS

          this.originalProducts =
            [...(res || [])];


          this.allProducts =
            [...this.originalProducts];


          this.filtered =
            [...this.originalProducts];


          this.buildHomeSections();


          /*
            IMPORTANT:
            Popular Categories আর
            product list থেকে তৈরি হবে না।

            এখন admin controlled
            /api/categories/popular
            endpoint থেকে আসবে।
          */


          this.loading = false;


          this.applySearch();


          this.cdr.detectChanges();
        },


        error: (err: any) => {

          console.error(
            'LOAD ALL ERROR =',
            err
          );


          this.loading = false;


          this.originalProducts = [];

          this.allProducts = [];

          this.filtered = [];


          /*
            এখানে popularCategories
            empty করছি না।

            কারণ Popular Categories
            আলাদা API থেকে load হচ্ছে।
          */


          this.cdr.detectChanges();
        }
      });
  }


  // =========================
  // HOT DEALS / RECOMMENDED / TRENDING
  //
  // • Hot Deals   : সবচেয়ে বেশি ডিসকাউন্টের প্রোডাক্ট আগে
  // • Trending    : সবচেয়ে বেশি বিক্রি (sold) হওয়া প্রোডাক্ট আগে
  //                 (এখনো কোনো বিক্রি না থাকলে নতুন প্রোডাক্ট দেখায়)
  // • Recommended : বিক্রি + ডিসকাউন্ট মিলিয়ে সেরা, Hot Deals/Trending-এ
  //                 যেগুলো আছে সেগুলো বাদ দিয়ে — যাতে একই প্রোডাক্ট বারবার না আসে
  // শুধু স্টকে থাকা প্রোডাক্ট দেখানো হয়।
  // =========================

  private buildHomeSections(): void {

    const LIMIT = 20;

    const hasImage = (p: any) =>
      !!(p?.imageUrl || p?.image_url);

    const inStock = (p: any) =>
      p && Number(p.stock) > 0;

    const live =
      this.originalProducts.filter(inStock);

    const withImg =
      live.filter(hasImage);

    const pool =
      withImg.length >= 10
        ? withImg
        : live;


    this.hotDeals =
      pool
        .filter(p => Number(p.discount) > 0)
        .sort((a, b) =>
          Number(b.discount) - Number(a.discount)
        )
        .slice(0, LIMIT);


    const bySold =
      [...pool]
        .filter(p => Number(p.sold) > 0)
        .sort((a, b) =>
          Number(b.sold) - Number(a.sold)
        );

    this.trending =
      (
        bySold.length > 0
          ? bySold
          : [...pool].sort(
              (a, b) => Number(b.id) - Number(a.id)
            )
      ).slice(0, LIMIT);


    const used =
      new Set<number>([
        ...this.hotDeals.map(p => Number(p.id)),
        ...this.trending.map(p => Number(p.id))
      ]);

    const score = (p: any) =>
      (Number(p.sold) || 0) * 2 +
      (Number(p.discount) || 0);

    const ranked =
      [...pool].sort((a, b) => score(b) - score(a));

    const fresh =
      ranked.filter(p => !used.has(Number(p.id)));

    // বাদ দেওয়ার পর যথেষ্ট না থাকলে বাকিগুলো দিয়ে ভরাট
    this.recommended =
      (
        fresh.length >= 10
          ? fresh
          : [...fresh, ...ranked.filter(p => used.has(Number(p.id)))]
      ).slice(0, LIMIT);
  }


  // =========================
  // LOAD CATEGORY PRODUCTS
  // =========================

  loadProducts(
    id: number
  ): void {

    console.log(
      'LOAD CATEGORY ID =',
      id
    );


    if (!id) {
      return;
    }


    this.loading = true;


    this.viewMode =
      'products';


    this.productService
      .getByCategory(id)
      .subscribe({

        next: (res: any[]) => {

          console.log(
            'CATEGORY PRODUCTS =',
            res
          );


          this.allProducts =
            [...(res || [])];


          this.filtered =
            [...this.allProducts];


          this.loading = false;


          this.applySearch();


          this.cdr.detectChanges();


          this.scrollToCategorySection();
        },


        error: (err: any) => {

          console.error(
            'CATEGORY ERROR =',
            err
          );


          this.loading = false;


          this.allProducts = [];

          this.filtered = [];


          this.cdr.detectChanges();
        }
      });
  }


  // =========================
  // SEARCH
  // =========================

 // সার্চ রেজাল্টে ফিল্টার (ব্র্যান্ড / ওজন / দাম / স্টক) — ব্রাউজারেই প্রয়োগ হয়
 onSearchFiltersChanged(f: ProductFilters): void {

   this.filtered = this.searchBase.filter((p: any) => {

     if (f.brands.length && !f.brands.includes((p?.brand ?? '').toString().trim())) {
       return false;
     }

     if (f.weights.length && !f.weights.includes((p?.weight ?? '').toString().trim())) {
       return false;
     }

     const price = Number(p?.price);

     if (f.minPrice !== null && f.minPrice !== undefined && price < Number(f.minPrice)) {
       return false;
     }

     if (f.maxPrice !== null && f.maxPrice !== undefined && price > Number(f.maxPrice)) {
       return false;
     }

     if (f.inStock && !(Number(p?.stock) > 0)) {
       return false;
     }

     return true;
   });

   this.cdr.detectChanges();
 }

 applySearch(): void {

   console.log('SEARCH =', this.currentSearch);

  const text = this.currentSearch.trim();

  if (!text) {

    this.filtered = [...this.allProducts];
    return;
  }

  this.loading = true;

  this.productService
      .searchProducts(text)
      .subscribe({

        next: (res: any[]) => {

          this.searchBase = [...res];

          this.filtered = [...res];

          this.loading = false;

          this.cdr.detectChanges();
        },

        error: err => {

          console.error(err);

          this.filtered = [];

          this.loading = false;

          this.cdr.detectChanges();
        }

      });
}

  // =========================
  // SEE ALL PRODUCTS
  // =========================

  onAllProducts(): void {

    console.log(
      'SEE ALL CLICKED'
    );


    this.mobileMenuOpen =
      false;


    this.selectedCategory =
      null;


    this.breadcrumb = [
      'All Products'
    ];


    this.viewMode =
      'products';


    this.allProducts =
      [...this.originalProducts];


    this.filtered =
      [...this.originalProducts];


    this.applySearch();


    this.cdr.detectChanges();


    this.scrollToCategorySection();
  }


  // =========================
  // SCROLL TO PRODUCTS
  // =========================

  scrollToCategorySection(): void {

    setTimeout(() => {

      if (!this.productsSection) {

        console.log(
          'productsSection not found'
        );

        return;
      }


      const navbarHeight =
        90;


      const elementTop =

        this.productsSection
          .nativeElement
          .getBoundingClientRect()
          .top

        + window.scrollY;


      window.scrollTo({

        top:
          elementTop -
          navbarHeight -
          15,

        behavior:
          'smooth'
      });

    }, 100);
  }


  // =========================
  // CATEGORY
  // =========================

  onCategory(
    data: any
  ): void {

    console.log(
      'CATEGORY CLICK =',
      data
    );


    this.mobileMenuOpen =
      false;

      this.router.navigate(['/category', data.id]);
return;


    if (!data) {
      return;
    }


    this.state.setSearch('');


    this.allProducts = [];

    this.filtered = [];


    // =========================
    // ALL PRODUCTS
    // =========================

    if (
      data.level === 'all' ||
      data.id === 0
    ) {

      this.onAllProducts();

      return;
    }


    // =========================
    // BREADCRUMB
    // =========================

    this.breadcrumb = [];


    if (data.mainName) {

      this.breadcrumb.push(
        data.mainName
      );
    }


    if (
      data.parentName &&
      data.parentName !==
        data.mainName
    ) {

      this.breadcrumb.push(
        data.parentName
      );
    }


    if (data.name) {

      this.breadcrumb.push(
        data.name
      );
    }


    // =========================
    // CATEGORY CHILDREN
    // =========================

    if (
      data.children &&
      data.children.length > 0
    ) {

      this.selectedCategory =
        data;


      this.viewMode =
        'categories';


      this.cdr.detectChanges();


      this.scrollToCategorySection();


      return;
    }


    // =========================
    // FINAL PRODUCTS
    // =========================

    this.selectedCategory =
      null;


    this.viewMode =
      'products';


    this.cdr.detectChanges();


    this.loadProducts(
      Number(data.id)
    );
  }


  // =========================
  // PRODUCT IMAGE
  // =========================

  getImage(
    url: string
  ): string {

    if (!url) {

      return 'assets/no-image.png';
    }


    if (
      url.startsWith('http')
    ) {

      return url;
    }


    if (
      url.startsWith('/uploads')
    ) {

      return `${this.apiUrl}${url}`;
    }


    return (
      `${this.apiUrl}/images/${url}`
    );
  }


  // =========================
  // CATEGORY IMAGE
  // =========================

  getCategoryImage(
    url: string
  ): string {

    if (!url) {

      return 'assets/no-image.png';
    }


    if (
      url.startsWith('http')
    ) {

      return url;
    }


    if (
      url.startsWith('/uploads')
    ) {

      return `${this.apiUrl}${url}`;
    }


    return (
      `${this.apiUrl}/images/${url}`
    );
  }


  // =========================
  // IMAGE ERROR
  // =========================

  onImgError(
    event: any
  ): void {

    event.target.src =
      'assets/no-image.png';
  }


  // =========================
  // DISCOUNTED PRICE (rounded, for card display)
  // =========================

  getFinalPrice(p: any): number {

    const price = Number(p?.price) || 0;
    const discount = Number(p?.discount) || 0;

    if (!discount) {
      return price;
    }

    return Math.round(price - (price * discount / 100));
  }


  // =========================
  // ADD TO CART
  // =========================

  addToCart(
    product: any,
    event?: Event
  ): void {

    event?.preventDefault();

    event?.stopPropagation();


    if (
      product.stock !== undefined &&
      product.stock !== null &&
      Number(product.stock) <= 0
    ) {

      return;
    }


    this.cart.add({
      ...product,
      price: this.getFinalPrice(product)
    });


    this.cdr.detectChanges();

  }


  // =========================
  // OPEN PRODUCT
  // (search-results grid had no click handler at all —
  // clicking a card here never navigated anywhere)
  // =========================

  openProduct(
    id: number
  ): void {

    if (!id) {
      return;
    }

    this.router.navigate([
      '/product',
      id
    ]);

  }


  // =========================
  // INCREASE QTY
  // =========================

  increaseQty(
    product: any,
    event?: Event
  ): void {

    event?.preventDefault();

    event?.stopPropagation();


    this.cart.increaseByProduct({
      ...product,
      price: this.getFinalPrice(product)
    });


    this.cdr.detectChanges();
  }


  // =========================
  // DECREASE QTY
  // =========================

  decreaseQty(
    product: any,
    event?: Event
  ): void {

    event?.preventDefault();

    event?.stopPropagation();


    this.cart.decreaseByProduct(
      product
    );


    this.cdr.detectChanges();
  }


  // =========================
  // GET CART QTY
  // =========================

  getCartQty(
    product: any
  ): number {

    return this.cart.getQty(
      product?.id
    );
  }


  // =========================
  // IS IN CART
  // =========================

  isInCart(
    product: any
  ): boolean {

    return (
      this.getCartQty(
        product
      ) > 0
    );
  }


  // =========================
  // TRACK BY
  // =========================

  trackByProduct(
    index: number,
    item: any
  ): any {

    return (
      item?.id ??
      index
    );
  }
}